import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "user",
  "use": "user-usage",
  "viewBox": "0 0 26 24",
  "content": "<symbol viewBox=\"0 0 26 24\" xmlns=\"http://www.w3.org/2000/svg\" id=\"user\"><path d=\"m20.4211 7.42134c0 4.09876-3.3228 7.42136-7.4213 7.42136-4.09872 0-7.42134-3.3228-7.42134-7.42136 0-4.09873 3.32255-7.42134 7.42134-7.42134 4.0988 0 7.4213 3.32255 7.4213 7.42134zm5.2174 16.57866c-.8479-4.5097-6.1815-7.9855-12.6386-7.9855-6.45704 0-11.79104 3.4758-12.638572 7.9855z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol